import { fetchApi } from '../config/api';

export const getEvents = async () => {
    try {
        console.log('Iniciando petición de eventos...');
        const response = await fetchApi('events');
        console.log('Respuesta de eventos recibida:', response);
        return response;
    } catch (error) {
        console.error('Error detallado al obtener eventos:', error);
        throw error;
    }
};

export const getActiveEvents = async () => {
    try {
        return await fetchApi('events?status=active');
    } catch (error) {
        console.error('Error fetching active events:', error);
        throw error;
    }
};

export const getPlannedEvents = async () => {
    try {
        return await fetchApi('events?status=planned');
    } catch (error) {
        console.error('Error fetching planned events:', error);
        throw error;
    }
}; 